const clientKey = "queueryte.client";

function storedClient(): string {
  try { return window.localStorage.getItem(clientKey) ?? ""; } catch { return ""; }
}
let client = typeof window === "undefined" ? "" : storedClient();

/** The client account a QueueRyte admin is working on. Ignored by the server for everyone else. */
export const actingClient = (): string => client;
export function setActingClient(id: string): void {
  client = id;
  try { if (id) window.localStorage.setItem(clientKey, id); else window.localStorage.removeItem(clientKey); } catch { /* storage can be unavailable */ }
}

export class ApiError extends Error {
  constructor(readonly status: number, message: string) { super(message); }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body !== undefined) headers.set("Content-Type", "application/json");
  if (init?.method && init.method !== "GET") headers.set("X-QueueRyte-CSRF", "1");
  if (client) headers.set("X-QueueRyte-Client", client);
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  const body = await response.json().catch(() => ({})) as { error?: { message?: string } };
  if (!response.ok) throw new ApiError(response.status, body.error?.message ?? "Request failed");
  return body as T;
}
